import { State } from 'src/types'
import { hamidashiOfNormal } from '../hamidashi/normal'
import { middleFingerLeft, middleFingerRight } from 'src/features/gorilla/drawer/glove/rightThrow/back/middleFinger'
import { ringFingerLeft, ringFingerRight } from 'src/features/gorilla/drawer/glove/rightThrow/back/ringFinger'
import { thumbEmbroideryDrawer } from 'src/features/gorilla/drawer/common/back/useCanvasEmbroideries'
import { indexFingerLeft, indexFingerRight } from '../indexFinger'
import { littleFingerLeft, littleFingerRight } from '../littleFinger'
import { thumbAndListBelt, thumbOut } from '../thumbAndListBelt'
import { listBelt } from '../listBelt'
import { indexFingerPad } from '../fingerCoverOrPad/indexFingerPad'
import { fingerCrotch } from '../fingerCrotch'
import { catchFace2 } from '../catchFace2'
import { edgeOfBeltBackStyle } from '../edge/edgeOfBeltBackstyle'
import { edgeOfWrist } from '../edge/edgeOfWrist'
import { middleFingerPad } from '../fingerCoverOrPad/middleFIngerPad'

// 通常ベルトモデル
export const beltBackStyleDrawer = (ctx: CanvasRenderingContext2D, state: State, needCatchFaceWrap: boolean): void => {
  const isIndexFingerPad = ['indexPad'].includes(state.fingerGuardType?.value)
  const isMiddleFingerPad = ['middlePad'].includes(state.fingerGuardType?.value)

  thumbAndListBelt(ctx, state.thumbWeb?.color, state.stitch?.color)
  thumbOut(ctx, state.thumbOut?.color) // 親指＿外

  // 人差し指＿右... UBackここで描いてる
  indexFingerRight(
    ctx,
    state,
    // needCatchFaceWrap ? state.indexWeb?.color : state?.thumbWebAndIndexWeb?.color,
    // state.catchFace.color,
    // state.hamidashi.color,
    needCatchFaceWrap
  )
  const isGorilla001Model = state.baseModel.productNumber === '001-20'
  const isBelt = ['normal', 'unselected', undefined].includes(state.beltType?.value) && !isGorilla001Model
  if (isBelt) {
    listBelt(ctx, state.listBelt?.color, state.stitch?.color)
  }

  // 人差し指＿左
  indexFingerLeft(ctx, state.indexMiddle?.color)
  // 中指＿右
  middleFingerRight(ctx, state.middleIndex?.color)
  // 中指＿左
  middleFingerLeft(ctx, state.middleRing?.color)
  // 薬指＿右
  ringFingerRight(ctx, state.ringMiddle?.color)
  // 薬指＿左
  ringFingerLeft(ctx, state.ringLittle?.color)

  // 小指＿右
  littleFingerRight(ctx, state.littleRing?.color)
  // 小指＿左
  littleFingerLeft(ctx, state.littleOut?.color)

  // ハミダシ
  hamidashiOfNormal(ctx, state.hamidashi?.color)
  // 捕球面 / ウェブ下折り返し
  catchFace2(ctx, state.catchFace?.color, state.stitch?.color, needCatchFaceWrap)

  edgeOfBeltBackStyle(ctx, state.edge?.color, state.stitch?.color)
  edgeOfWrist(ctx, state.edge?.color, state.stitch?.color)

  // 指当て(人指し指)
  isIndexFingerPad && indexFingerPad(ctx, state.indexCover.color, state.stitch.color)
  // 指当て(中指)
  isMiddleFingerPad && middleFingerPad(ctx, state.indexCover.color, state.stitch.color, -165, 90, -15)
  // 指股
  fingerCrotch(ctx, state.catchFace?.color, state.hamidashi?.color, state.baseModel?.isFingerCrotch)

  thumbEmbroideryDrawer(ctx, state.embroideries)
}
